module.exports = __webpack_public_path__ + "img/odometer.2e679a04.svg";